// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resendCodeContainer {
    width: 100%;
    min-height: 100vh;
    background: #0c0b20;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 40px 0;
}

.resendCodeContent {
    display: flex;
    flex: 1 1;
    width: 100%;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    max-width: 500px;
}

.resendCodeContent h2 {
    font-size: 20px;
    text-align: center;
    width: 100%;
    margin-bottom: 16px;
}

.resendCodeForm {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
}

.resendCodeForm label {
    font-size: 16px;
    color: #ddd;
}

.resendCodeForm input {
    display: flex;
    padding: 10px 12px;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px;
    background: #fff;
    border: none;
    color: #000;
}

.resendCodeForm button {
    display: flex;
    padding: 12px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 32px;
    background: #C3D32C;
    font-size: 16px;
    border: none;
    color: #000;
    cursor: pointer;
    transition: background 0.3s ease;
}

.resendCodeForm button:disabled {
    background: #888; /* Grise le bouton quand il est désactivé */
    cursor: not-allowed;
}

.message,
.error {
    text-align: center;
    font-size: 14px;
    padding: 10px;
    border-radius: 8px;
    margin-top: 10px;
    width: 100%;
}

.message {
    background: #7acc7a; /* Vert clair pour les messages de succès */
    color: #000;
}

.error {
    background: #ff5f5f; /* Rouge clair pour les messages d'erreur */
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/assets/Styles/ResendCode.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,gBAAgB,EAAE,2CAA2C;IAC7D,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB,EAAE,2CAA2C;IAChE,WAAW;AACf;;AAEA;IACI,mBAAmB,EAAE,2CAA2C;IAChE,YAAY;AAChB","sourcesContent":[".resendCodeContainer {\r\n    width: 100%;\r\n    min-height: 100vh;\r\n    background: #0c0b20;\r\n    color: white;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 10px;\r\n    padding: 40px 0;\r\n}\r\n\r\n.resendCodeContent {\r\n    display: flex;\r\n    flex: 1;\r\n    width: 100%;\r\n    padding: 16px;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 16px;\r\n    max-width: 500px;\r\n}\r\n\r\n.resendCodeContent h2 {\r\n    font-size: 20px;\r\n    text-align: center;\r\n    width: 100%;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.resendCodeForm {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    gap: 8px;\r\n}\r\n\r\n.resendCodeForm label {\r\n    font-size: 16px;\r\n    color: #ddd;\r\n}\r\n\r\n.resendCodeForm input {\r\n    display: flex;\r\n    padding: 10px 12px;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-radius: 10px;\r\n    background: #fff;\r\n    border: none;\r\n    color: #000;\r\n}\r\n\r\n.resendCodeForm button {\r\n    display: flex;\r\n    padding: 12px;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 4px;\r\n    border-radius: 32px;\r\n    background: #C3D32C;\r\n    font-size: 16px;\r\n    border: none;\r\n    color: #000;\r\n    cursor: pointer;\r\n    transition: background 0.3s ease;\r\n}\r\n\r\n.resendCodeForm button:disabled {\r\n    background: #888; /* Grise le bouton quand il est désactivé */\r\n    cursor: not-allowed;\r\n}\r\n\r\n.message,\r\n.error {\r\n    text-align: center;\r\n    font-size: 14px;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    margin-top: 10px;\r\n    width: 100%;\r\n}\r\n\r\n.message {\r\n    background: #7acc7a; /* Vert clair pour les messages de succès */\r\n    color: #000;\r\n}\r\n\r\n.error {\r\n    background: #ff5f5f; /* Rouge clair pour les messages d'erreur */\r\n    color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
